import {Action, Module, Mutation} from 'vuex-module-decorators'
import store, {currentUserModule, studyModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import StudyPatientShortDto = MdbsCore.StudyPatientShortDto;
import Rights = MdbsCore.Rights;

const studyPatientClient = new MdbsCore.StudyPatientClient();

@Module({namespaced: true, name: 'studyPatients', store: store})
export default class StudyPatientsModule extends BaseModule {
    studyPatients = new Array<StudyPatientShortDto>();
    isLoaded = false

    @Mutation
    setStudyPatients(studyPatients: Array<StudyPatientShortDto>) {
        this.studyPatients.updateValues(studyPatients);
        this.isLoaded = true;
    }

    @Mutation
    reset() {
        this.studyPatients.clear();
        this.isLoaded = false;
    }

    @Action({rawError: true})
    async loadAll(includeDeleted?: boolean) {
        await this.execute(async () => {
                const studyId = studyModule.study?.id ?? "";
                const studyPatients = currentUserModule.hasRight(Rights.StudyPatientGetAllCmd)
                    ? await studyPatientClient.getAllStudyPatients(includeDeleted)
                    : await studyPatientClient.getMyStudyPatients(studyId, includeDeleted);
                this.setStudyPatients(studyPatients)
            }
        ).catch(() => this.reset());
    }

    @Action({rawError: true})
    async loadMy(includeDeleted?: boolean) {
        const study = studyModule.study.id;
        await this.execute(async () =>
            this.setStudyPatients(await studyPatientClient.getMyStudyPatients(study, includeDeleted))
        ).catch(() => this.reset());
    }
}
